import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { organizationAtom } from 'services/organization/atom';
import { userAtom } from 'services/user/atoms';
import { removeFalsyValues } from 'utils/fomatting';

declare global {
  interface Window {
    pendo: any;
  }
}

const useTrackingInit = () => {
  const posthog = usePostHog();
  const user = useRecoilValue(userAtom);
  const organization = useRecoilValue(organizationAtom);

  useEffect(() => {
    if (user && organization) {
      posthog?.identify(user.id, {
        email: user.email,
        name: user.name,
        id: user.id,
        organizationGroupId: user.organizationGroupId
      });
      posthog?.group('organization', organization.id, {
        name: organization?.name,
        id: organization.id,
        organizationGroupId: user.organizationGroupId
      });
      if (window.pendo) {
        window.pendo.initialize({
          visitor: {
            id: user.id,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName
          },
          account: {
            id: organization.id,
            accountName: organization.name
          }
        });
      }
    }
  }, [organization, user]);
};

const useTracking = () => {
  const posthog = usePostHog();

  const track = (event: string, properties?: Record<string, any>) => {
    posthog?.capture(event, properties && removeFalsyValues(properties));
  };

  return { track };
};

export { useTrackingInit, useTracking };
